module.exports = __webpack_public_path__ + "assets/images/oppo.bcb85b04aa4f961a3f228b53f626a2ab.png";